module.exports = __webpack_public_path__ + "static/media/decohouse_lg.8468522f.png";